import Component from '../core/Component'
import Litepicker from 'litepicker'

export default class InputDate extends Component {

    prepare() {
        this.picker = new Litepicker({
            element: this.element,
            format: 'D.M.YYYY',
            lang: 'cs',
            dropdowns: {
                minYear: 1950,
                maxYear: null,
                months: true,
                years: true
            }
        })
    }
}
